import { Helmet } from 'react-helmet-async';
import React from 'react';

interface PageTitleProps {
	title: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title }) => (
	<Helmet>
		<title>{title} - Suigar</title>
	</Helmet>
);
